 
import React from "react";
import Container from "@mui/material/Container";
import Helmet from "react-helmet";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export const SFPageContainer = ({ sx, children }) => (
  <Container sx={sx} maxWidth={false} disableGutters>
    {children}
  </Container>
);

export const SFContentContainer = ({
  sx = {},
  className = null,
  backgroundImage = null,
  disableGutters = false,
  hideGradient = false,
  showTopMargin = false,
  showSideMargins = false,
  children,
  backgroundImageProps = {},
}) => {
  const theme = useTheme();
  let bg = {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    backgroundSize: "cover",

    ...backgroundImageProps,
  };

  let bodyStyles = "";
  if (hideGradient || backgroundImage) {
    bodyStyles += `
      background-color: #1A1B24 !important;
    `;
  } else {
    bodyStyles += `
    background-color: #1A1B24 !important;
    background: linear-gradient(
        108.45deg,
        rgba(121, 116, 128, 0) 12.64%,
        rgba(116, 116, 128, 0.252) 30.32%,
        rgba(116, 116, 128, 0.145208) 48.33%,
        rgba(116, 116, 128, 0.252) 66.02%,
        rgba(116, 116, 128, 0) 83.69%
      );
      background-size: 300% 300%;
  `;
  }
  if (backgroundImage) {
    bodyStyles += `
      background-color: #1A1B24 !important;
      background: linear-gradient(270deg, rgba(26, 26, 36, 0) 0%, rgba(26, 26, 36, 0.8) 49.48%), linear-gradient(360deg, rgba(26, 26, 36, 0.9) 42.71%, rgba(26, 26, 36, 0) 100%), url(${backgroundImage});
      background-position: ${bg.backgroundPosition};
      background-repeat: ${bg.backgroundRepeat};
      background-attachment: ${bg.backgroundAttachment};
      background-size: ${bg.backgroundSize};
    `;
  }

  return (
    <>
      {!process.env.REACT_APP_EYWP_MFE_ENV_FILE && <Helmet bodyAttributes={{ style: bodyStyles }} /> }
      <Container
        className={className}
        disableGutters={disableGutters}
        sx={{
          ...(showTopMargin && { paddingTop: "30px" }),
          height: "100%",
          ...(showSideMargins && {
            ...(useMediaQuery(theme.breakpoints.up("md")) && {
              paddingLeft: "80px !important",
              paddingRight: "40px !important",
            }),
          }),
          // paddingLeft: "80px !important",
          // paddingRight: "40px !important",
          display: "flex",
          flexDirection: "column",
          ...sx,
        }}
        maxWidth={false}
      >
        {children}
      </Container>
    </>
  );
};

export default SFPageContainer;
